module.exports = __webpack_public_path__ + "img/video-remove.f7df69cb.svg";